<template>
  <div class="containerCenter">
    <div class="containerLeft">
      <div class="top">
        <a-input allowClear class="first" v-model="queryParam" placeholder="请输入类型名称" @keyup.enter.native="search" />
        <a-button type="primary" @click="serchTree" style="margin-left: 10px;"> 查询 </a-button>
      </div>
      <div class="line"></div>
      <div class="treeBox">
        <a-tree :tree-data="treeData" show-icon default-expand-all :replace-fields="replaceFields"
          :expanded-keys="expandedKeys" :auto-expand-parent="autoExpandParent" @select="onSelectCate" @expand="onExpand">
          <template slot="custom" slot-scope="item">
            <span v-if="item.name.indexOf(searchValue) > -1">
              {{ item.name.substr(0, item.name.indexOf(searchValue)) }}
              <span style="color: #f50">{{ searchValue }}</span>
              {{ item.name.substr(item.name.indexOf(searchValue) + searchValue.length) }}
            </span>
            <span v-else>{{ item.name }}</span>
            <span class="but_operation">
              <a-icon type="edit" class="but_type" style="color:#409EFF" title="编辑" @click.stop="editCate(item)" />
              <a-icon type="delete" class="but_type" style="color:red" title="删除" @click.stop="delCate(item)" />
            </span>
          </template>
        </a-tree>
      </div>
      <div class="newBtn">
        <a-button type="primary" class="newCBtn" @click="addNewCate">新增</a-button>
      </div>
    </div>
    <div class="containerRight">
      <div class="top">
        <a-select allowClear class="a_enter" placeholder="启禁用状态" v-model="query.isLive">
          <a-select-option :value="item.value" v-for="(item, index) in statusData" :key="index">{{ item.title }}
          </a-select-option>
        </a-select>
        <a-button type="primary" @click="search"> 查询 </a-button>
        <a-button type="primary" icon="plus" @click="addType" :disabled="dataRef&&dataRef.parentId=='0'">新增单据模板
        </a-button>
      </div>
      <div class="content_main_center_scroll" id="content_main_center_scroll">
        <a-table :data-source="list" ref="bodyTop" :pagination="false" bordered :loading="loading"
          :scroll="{ y: tableScrollY, scrollToFirstRowOnChange: true ,x: 1200}" @change="handleTableChange">
          <a-table-column key="name" data-index="BaseInformation.name" title="费用类别" width="130px" fixed='left' />
          <a-table-column key="mark" data-index="BaseInformation.mark" title="说明提示" width="160px" fixed='left' />
          <a-table-column key="level" data-index="BaseInformation.level" title="排序" width="80px" />
          <a-table-column key="live" data-index="BaseInformation.live" title="启禁用">
            <template slot-scope="text, record">{{text==0?'禁用':'启用'}}</template>
          </a-table-column>
          <a-table-column key="processKey" data-index="BaseInformation.processKey" title="关联类型">
             <template slot-scope="text, record">{{typeList[text]}}</template>
          </a-table-column>
          <a-table-column key="number" data-index="number" title="版本" />
          <a-table-column key="createBy" data-index="BaseInformation.createBy" title="创建人" />
          <a-table-column key="createTime" data-index="BaseInformation.createTime" title="创建时间" />
          <a-table-column key="updateBy" data-index="BaseInformation.updateBy" title="更新人" />
          <a-table-column key="updateTime" data-index="BaseInformation.updateTime" title="更新时间" />
          <a-table-column key="action" title="操作" width="200px" fixed="right" >
            <template slot-scope="text, record">
              <span>
                <a @click.stop="setActive(record)">{{record.BaseInformation.live==0?'启用':'禁用'}}</a>
                <a-divider type="vertical" />
                <a @click.stop="editTem(record)">编辑</a>
                <a-divider type="vertical" />
                <a @click.stop="delData(record)">详情</a>
                <a-divider type="vertical" />
                <a @click.stop="delTem(record)">删除</a>
                <!-- <a-divider type="vertical" />
                <a @click.stop="permissionSet(record)">设置</a> -->
              </span>
            </template>
          </a-table-column>
        </a-table>
      </div>
    </div>
    <!-- 分类维护 -->
    <a-modal class="" title="分类维护" :visible="isShowCate" @cancel="isShowCate=false" width="35%" @ok="handleOkCate">
      <a-form-model :model="formCate" ref="formCate" :rules="rulesCate" class="formCate">
        <a-form-model-item label="上级分类">
          <a-select style="width: 100%" v-model="formCate.typeIdx" placeholder="如果当前为第一级分类不用进行选择" allowClear>
            <a-select-option v-for="(item,index) in treeData" :key="index" :value="item.id">{{item.name}}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="分类名称" prop="name">
          <a-input v-model="formCate.name" placeholder="最多填写10个字符" allowClear></a-input>
        </a-form-model-item>
         <a-form-model-item label="分类序号" prop="level">
          <a-input v-model="formCate.level" placeholder="请输入" allowClear oninput="this.value=this.value.replace(/\D/g,'');if(isNaN(value))execCommand('undo');"></a-input>
        </a-form-model-item>
      </a-form-model>
      <div class="modelCate">
        <a-icon type="info-circle" style="color:#FFA39E;margin-right:5px;font-size: 18px;margin-left:10px" />
        <div style="margin-right:10px;font-weight: 600;color:#666">提示</div>
        <div>当前仅支持维护致第二级分类</div>
      </div>
    </a-modal>
    <!-- 编辑模板弹框 -->
    <a-modal class="" :title="isNew=='add'?'单据模板-新增':'单据模板-编辑'" :visible="categoryVisible"
      @cancel="closeVisible" width="60%">
      <template slot="footer">
        <a-button key="back" @click="categoryVisible=false">取消</a-button>
        <a-button key="back" type="primary" @click="preBack" v-if="stepCurrent>0">上一步</a-button>
        <a-button key="submit" type="primary" @click="submit">{{stepCurrent>0?'完成':'下一步'}}</a-button>
      </template>
      <div class="containerTop">
        <a-steps v-model="stepCurrent" size="small">
          <a-step title="明细字段维护" disabled />
          <a-step title="基础信息维护" disabled />
          <a-step title="完成" disabled />
        </a-steps>
      </div>
      <div class="containerBottom" v-if="stepCurrent==0">
        <div class="view">
          <div class="ico">
            <a-icon class="circle" type="info-circle" />
          </div>
          <div class="hiteBox">
            <div class="hb">说明</div>
            <div class="hite">您可以基于【财务规则】来配置所需的费用明细。【支付金额】不必在此进行维护；</div>
          </div>
        </div>
        <div class="tableSelect">
          <a-table :data-source="modelInfo.data" ref="bodyTop" :pagination="false" bordered>
            <a-table-column key="id" data-index="id" title="选择控件" width="240px">
              <template slot-scope="text, record,index">
                <a-select v-model="record.id" style="width: 100%" placeholder="请选择" show-search :filter-option="filterOption"
                  @change="changeFormItem($event,record,index)">
                  <a-select-option v-for="(item,idx) in configs" :key="idx" :value="item.id">{{item.label}}
                  </a-select-option>
                </a-select>
              </template>
            </a-table-column>
            <a-table-column key="context" data-index="context" title="选项">
              <template slot-scope="text, record">
                <a-input v-model="record.context" placeholder="请输入" :disabled="record.type!='Redio'"></a-input>
              </template>
            </a-table-column>
             <a-table-column key="sort" data-index="sort" title="排序">
              <template slot-scope="text, record,index">
                <a-button icon="vertical-align-top" :size="size" @click="setTop(index)" :disabled="modelInfo.data.length < 2 || index == 0"/>
                <a-button icon="arrow-up" :size="size" @click="setUp(index)" :disabled="modelInfo.data.length < 2 || index == 0" />
                <a-button icon="arrow-down" :size="size" @click="setDown(index)" :disabled="modelInfo.data.length < 2 || index >= modelInfo.data.length-1" />
                <a-button icon="vertical-align-bottom" :size="size" @click="setBottom(index)" :disabled="modelInfo.data.length < 2 || index >= modelInfo.data.length-1"/>
                <!-- <a-input v-model="record.sort" placeholder="请输入" :disabled="record.type!='Redio'"></a-input> -->
              </template>
            </a-table-column>
            <a-table-column key="required" data-index="required" title="是否必填" width="150px">
              <template slot-scope="text, record">
                <a-switch default-checked v-model="record.required" />
              </template>
            </a-table-column>
            <a-table-column key="required" data-index="required" title="插入至明细名称" width="150px" >
              <template slot-scope="text, record">
                <a-switch default-checked v-model="record.control_id" @click="isSwitch(record)" :disabled="only && !record.control_id "/>
              </template>
            </a-table-column>
            <a-table-column key="action" title="操作" width="70px">
              <template slot-scope="text, record,index">
                <span>
                  <a @click.stop="removeItemForm(index)">移除</a>
                </span>
              </template>
            </a-table-column>
          </a-table>
        </div>
        <div class="newSelect">
          <a-button class="newDetial" type="dashed" icon="plus" @click="addItemForm">新增字段明细</a-button>
        </div>
      </div>
      <div class="containerBottom" v-if="stepCurrent==1">
        <a-form-model :model="modelInfo.BaseInformation" ref="modelInfo"  :rules="rules" :label-col="{ span: 7 }" :wrapper-col="{ span: 17 }">
          <!-- <div class="selfModel"> -->
            <a-row >
              <a-col :span="8">
                  <a-form-model-item label="费用类别名称" prop="name">
                    <a-input v-model="modelInfo.BaseInformation.name" placeholder="请输入费用类别名称" />
                  </a-form-model-item>
              </a-col>
              <a-col :span="8">
                  <a-form-model-item label="归属类别" prop="type" v-if="isNew =='add'">
                    <a-input v-model="modelInfo.BaseInformation.type" disabled placeholder="请输入归属类别" />
                  </a-form-model-item>
                  <a-form-model-item label="归属类别" prop="directoryId" v-else>
                      <a-select style="width: 100%" v-model="modelInfo.BaseInformation.directoryId" placeholder="请选择" allowClear>
                        <a-select-option v-for="(item,index) in directoryData" :key="index" :value="item.id">{{item.name}}
                        </a-select-option>
                      </a-select>
                  </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item label="关联审批流" prop="processKey">
                    <a-select  allowClear  placeholder="请选择关联审批流类型"  v-model="modelInfo.BaseInformation.processKey"  @change="changgeType"
                                style="width: 100%;" show-search :filter-option="filterOption">
                        <a-select-option :value="item.id" v-for="(item, index) in Approvallist" :key="index">
                            {{ item.name }}
                        </a-select-option>
                    </a-select>
                  <!-- <a-select v-model="modelInfo.BaseInformation.processKey" style="width: 100%" placeholder="请选择审批流">
                    <a-select-option value="1">关联 </a-select-option>
                    <a-select-option value="2">不关联 </a-select-option>
                  </a-select> -->
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="8">
                <a-form-model-item label="排序" prop="level">
                  <a-input v-model="modelInfo.BaseInformation.level"  placeholder="请输入" oninput="this.value=this.value.replace(/\D/g,'');if(isNaN(value))execCommand('undo');" />
                </a-form-model-item>
              </a-col>
            </a-row>
          <!-- </div> -->
        </a-form-model>
        <div class="boxlen">
          <div class="boxtitle">说明提示 <a-tooltip placement="topLeft"
              title="此说明，维护完成后会在【应用层同步显示】，您可以提示用户此流程需要注意的相关的规则信息等内容；">
              <a-icon type="info-circle" class="boxlencircle" />
            </a-tooltip>
          </div>
          <a-textarea v-model="modelInfo.BaseInformation.mark" placeholder="请输入提示内容"
            :auto-size="{ minRows: 2, maxRows: 5 }" />
        </div>
        <div class="boxlen">
          <div class="boxtitle">默认抄送人 </div>
          <a-select mode="multiple" label-in-value :value="value" v-model="modelInfo.BaseInformation.ccs"
            placeholder="请选择" style="width: 100%" :filter-option="false"
            :not-found-content="fetching ? undefined : null" @search="fetchUser">
            <a-spin v-if="fetching" slot="notFoundContent" size="small" />
            <a-select-option v-for="(item,index) in users" :key="index" :value="item.userId" >
              {{ item.userName }}
            </a-select-option>
          </a-select>
        </div>
        <div class="boxlen">
          <div class="boxtitle">参数配置 </div>
          <div class="sys">
            <div style="font-weight: 700; color: black;margin-bottom:5px;"><span style="color: #1990FF;">1、</span>项目相关参数</div>
            <div class="sysItem">
              <div class="sysTitle">是否需要维护【项目信息】（已付金额）?</div>
              <div class="sysline">
                <a-divider dashed></a-divider>
              </div>
              <a-switch default-checked v-model="modelInfo.BaseInformation.isCheckInformation" :disabled="modelInfo.BaseInformation.isReceived" />
            </div>
            <div class="sysItem">
              <div class="sysTitle">是否需要维护【项目信息】（项目已回款）?</div>
              <div class="sysline">
                <a-divider dashed></a-divider>
              </div>
              <a-switch default-checked v-model="modelInfo.BaseInformation.isReceived" :disabled="modelInfo.BaseInformation.isCheckInformation"/>
            </div>
            <!-- <div class="sysItem">
              <div class="sysTitle">是否需要维护【项目信息】 （未结算金额）?</div>
              <div class="sysline">
                <a-divider dashed></a-divider>
              </div>
              <a-switch default-checked v-model="modelInfo.BaseInformation.isServicePay" />
            </div> -->
            <div class="sysItem">
              <div class="sysTitle">是否需要收集项目金额进行判断？</div>
              <div class="sysline">
                <a-divider dashed></a-divider>
              </div>
              <a-switch default-checked v-model="modelInfo.BaseInformation.isCheckProjectMoney" />
            </div>
            <div class="sysItem">
              <div class="sysTitle">是否需要查询项目信息？</div>
              <div class="sysline">
                <a-divider dashed></a-divider>
              </div>
              <a-switch default-checked v-model="modelInfo.BaseInformation.isFindProject" />
            </div>
           
            <div style="font-weight: 700; color: black;margin-bottom:5px;"><span style="color: #1990FF;">2、</span>关联审批参数</div>
            <div class="sysItem">
              <div class="sysTitle">此【类别】是否需要关联其他【审批】信息？</div>
              <div class="sysline">
                <a-divider dashed></a-divider>
              </div>
              <a-switch default-checked v-model="modelInfo.BaseInformation.isRelationAudit" />
            </div>
            <div class="sysItem">
              <div class="sysTitle">此【类别】是否需要关联其他【采购物品】信息？</div>
              <div class="sysline">
                <a-divider dashed></a-divider>
              </div>
              <a-switch default-checked v-model="modelInfo.BaseInformation.isRelationPurchase" />
            </div>
            <div style="font-weight: 700; color: black;margin-bottom:5px;"><span style="color: #1990FF;">3、</span>报销参数配置</div>
             <div class="sysItem">
              <div class="sysTitle">此【类别】中【发票信息】是否【必填】？</div>
              <div class="sysline">
                <a-divider dashed></a-divider>
              </div>
              <a-switch default-checked v-model="modelInfo.BaseInformation.isCheckBill" />
            </div>
            <div class="sysItem">
              <div class="sysTitle">是否支持支付宝账户场景？</div>
              <div class="sysline">
                <a-divider dashed></a-divider>
              </div>
              <a-switch default-checked v-model="modelInfo.BaseInformation.isAlipay" />
            </div>
            <div class="sysItem">
              <div class="sysTitle">是否把控“自己申请自己”的款项？</div>
              <div class="sysline">
                <a-divider dashed></a-divider>
              </div>
              <a-switch default-checked v-model="modelInfo.BaseInformation.isControllerSelf" />
            </div>
            <div class="sysItem">
              <div class="sysTitle">记录费用归属公司</div>
              <div class="sysline">
                <a-divider dashed></a-divider>
              </div>
              <a-switch default-checked v-model="modelInfo.BaseInformation.isFeeDept" />
            </div>

          </div>
        </div>
      </div>
    </a-modal>
    <detailModel ref="detailModel"></detailModel>
    <permissinon ref="permissinon"></permissinon>
  </div>
</template>

<script>
import permissinon from './components/permissionSetting.vue'
import detailModel from './components/detail.vue'
import {
  getDeptListEnable3
} from '@/api/system.js'
import { get_directoryList, add_directory, del_directory, edit_directory, get_templatelist, set_active, del_template, get_confiig, add_template, get_template, put_template ,audit_list, getSecondDir} from '@/api/financial'
const getParentKey = (key, tree) => {
      let parentKey;
      for (let i = 0; i < tree.length; i++) {
        const node = tree[i];
        if (node.child) {
          if (node.child.some(item => item.id === key)) {
            parentKey = node.id;
          } else if (getParentKey(key, node.child)) {
            parentKey = getParentKey(key, node.child);
          }
        }
      }
      return parentKey;
    };
export default {
  components: {
     detailModel,
     permissinon,
    },

  data() {
    return {
      directoryData: [],
      Approvallist: [],
      typeList: [],
      autoExpandParent: true,
      searchValue: '',
      expandedKeys: [],
      query: {
        isLive: 0,
      },
      scroll_y: 150,
      statusData: [{
        title: '全部',
        value: 0,
      },
      {
        title: '启用',
        value: 1,
      },
      {
        title: '禁用',
        value: 2,
      }],
      dataRef: '',
      queryParam: '',
      treeData: [],
      treeId: '',
      isShowCate: false,
      replaceFields: {
        title: 'name',
        key: 'id',
        children: 'child'
      },
      isNewCate: 'add',
      formCate: {
        level: '',
        id: undefined,
        parentId: '0',
        typeIdx: undefined,
        name: '',
        type: 'payment',
      },
      rulesCate: {
        name: [
          { required: true, message: '请输入分类名称', trigger: 'blur' },
          { min: 3, max: 10, message: '请输入3到10个字符', trigger: 'blur' },
        ],
        level: [
          { required: true, message: '请输入分类序号', trigger: 'blur' },
        ]
      },
      loading: false,
      tableScrollY: 300,
      pagination1: {
        current: 1,
        pageSize: 20,
        total: 0,
        pageSizeOptions: ['20', '30', '40', '50'],
        showSizeChanger: true,
        itemName: '',
        hideOnSinglePage: false
      },
      list: [],
      //弹窗
      isNew: 'add',
      categoryVisible: false,
      stepCurrent: 0,//步骤
      modelInfo: {
        id: undefined,
        data: [],
        BaseInformation: {
          level: '',
          name: "",
          processKey: undefined,
          type: "",
          mark: "",
          cc: "",
          ccs: [],
          isCheckInformation: false,
          isReceived: false,
          isCheckBill: false,
          isRelationAudit: false,
          isRelationPurchase: false,
          isControllerSelf: false,
          isAlipay: false,
          isFeeDept: false,
          isCheckProjectMoney: false,
          directoryId: "634fafc0ca8ee0541b6fad08",
          live: 1,
        }
      },
      fetching: false,
      rules: {
        name: [
          { required: true, message: '请输入费用类别名称', trigger: 'blur' },
          { min: 2, max: 14, message: '文字长度 2 至 14', trigger: 'blur' },
        ],
        type: [
          { required: true, message: '请选择归属类别', trigger: 'blur' },
        ],
        audit: [
          { required: true, message: '请选择审批流', trigger: 'blur' },
        ],
        processKey: [
          { required: true, message: '请选择审批流', trigger: 'blur' },
        ],
        level: [
          { required: true, message: '请输入模板排列序号', trigger: 'blur' }
        ]
      },
      configs: [],
      information: '',
      users: [],
      only: false,
      control_id: []
    }
  },
  mounted() {
    this.get_pro_lis()
    this.$nextTick(() => {
      var max_h = $('#content_main_center_scroll').height()
      setTimeout(() => {
        this.tableScrollY = max_h - $('.ant-table-header').height()
      }, 500)
    })
    this.getList()
  },
  methods: {
    //权限设置
    permissionSet(record) {
      this.$refs.permissinon.init(record)
    },
    closeVisible() {
      this.only = false
      this.categoryVisible = false
    },
    //只能选择一个名称
    isSwitch(record) {
      // setTimeout(() => {
        // for(var i = 0; i < this.modelInfo.data.length; i++) {
        //     if( this.modelInfo.data[i].control_id) {
        //       this.only = true
        //       return 
        //     } else {
        //       this.only = false
        //       return 
        //     }
          
        // }
        this.only = false
        this.control_id = []
          this.modelInfo.data.forEach(item => {
             console.log(item ,'item1111111111=================')
          if(item.control_id) {
            console.log(item ,'item=================')
            this.control_id.push(item.id) 
           return this.only = true
          } 
        })
        console.log(this.only, 'this.only==============')
        this.$forceUpdate()
      // },200)
      
      
    },
    // 置顶
    setTop(index) {
      var data = JSON.parse(JSON.stringify(this.modelInfo.data[index]))
      this.modelInfo.data.unshift(data)
      this.modelInfo.data.splice(index+1,1)

    },
    setUp(index) {
      // var data1 = this.modelInfo.data[index-1]
      var data2 = JSON.parse(JSON.stringify(this.modelInfo.data[index]))
      this.modelInfo.data.splice(index,1)
      this.modelInfo.data.splice(index-1,0,data2)

    },
    setDown(index){
      var data2 = JSON.parse(JSON.stringify(this.modelInfo.data[index]))
      this.modelInfo.data.splice(index+2,0,data2)
      this.modelInfo.data.splice(index,1)


    },
    setBottom(index){
      var data = this.modelInfo.data[index]
      this.modelInfo.data.push(data)
      this.modelInfo.data.splice(0,1)

    },
    //下拉控件查询
    filterOption(input, option) {
				return (
					option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
				);
			},
    getList() {
			 audit_list({
         type: 'payment-'
       }).then((res) => {
				if (res.code == 200) {
				this.Approvallist = res.data
        this.Approvallist.forEach(item => {
          this.typeList[item.id] = item.name

        })
        
				console.log(this.Approvallist, 'this.Approvallist')
				}
			})
		},
    //搜索树
    serchTree() {
      var dataList = []
      for (let i = 0; i < this.treeData.length; i++) {
        const node = this.treeData[i];
        const key = this.treeData[i].id;
        dataList.push({ key, title: this.treeData[i].name });
        if (node.child.length) {
          var child = node.child
          child.forEach(item => {
            var k = item.id
            dataList.push({ key:k, title: item.name });
          })
        }
      }
      console.log(dataList)
      const expandedKeys = dataList
        .map(item => {
          if (item.title.indexOf(this.queryParam) > -1) {
            return getParentKey(item.key, this.treeData);
          }
          return null;
        })
        .filter((item, i, self) => item && self.indexOf(item) === i);
      this.expandedKeys = expandedKeys;
      this.searchValue = this.queryParam;
      this.autoExpandParent= true;
    },
    onExpand(expandedKeys) {
      this.expandedKeys = expandedKeys;
      this.autoExpandParent = false;
    },
    //获取树状列表
    get_pro_lis() {
      get_directoryList({ type: 'payment' }).then(res => {
        if (res.code != 200) {
          return this.$message.error(res.msg);
        }
        var lis = res.data;
        lis.forEach(item => {
          var childs = item.child;
          item['slots'] = item
          item['scopedSlots'] = { icon: 'file-text', title: 'custom' }
          childs.forEach(em => {
            item['slots'] = em
            em['scopedSlots'] = { icon: 'file-text', title: 'custom' }
          })
        })
        this.treeData = lis
      })
    },
    //点击新增分类
    addNewCate() {
      this.formCate.name = '';
      this.formCate.level = '';
      this.formCate.typeIdx = undefined;
      this.isNewCate = 'add';
      this.isShowCate = true;
    },
    editCate(item) {
      this.formCate = {
        id: item.id,
        parentId: item.parentId == '0' ? undefined : item.parentId,
        typeIdx: item.parentId == '0' ? undefined : item.parentId,
        name: item.name,
        type: 'payment',
        level: item.level,
      },
        this.isNewCate = 'edit';
      this.isShowCate = true;
    },
    //删除目录
    delCate(row) {
      var _this = this;
      this.$confirm({
        title: '确认删除此分类吗?',
        onOk() {
          del_directory({ id: row.id }).then(res => {
            if (res.code != 200) {
              return _this.$message.error(res.msg);
            };
            _this.get_pro_lis()
            _this.$message.success('删除成功');
          })
        },
        onCancel() {
          console.log('Cancel');
        },
        class: 'test',
      });
    },
    //保存树形目录
    handleOkCate() {
      this.$refs.formCate.validate(async valid => {
        if (valid) {
          this.formCate['parentId'] = !this.formCate.typeIdx ? '0' : this.formCate.typeIdx;
          if (this.isNewCate == 'add') {
            var res = await add_directory(this.formCate)
          } else {
            var res = await edit_directory(this.formCate)
          }
          if (res.code != 200) {
            return this.$message.error(res.msg);
          };
          this.get_pro_lis()
          this.$message.success('保存成功');
          this.$refs.formCate.resetFields()
          this.isShowCate = false;
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    //点击目录
    onSelectCate(selectedKeys, info) {
      this.dataRef = info.node.dataRef;
      console.log(this.dataRef)
      this.treeId = info.node.eventKey;
      this.get_list()
    },
    //获取模板列表
    get_list() {
      this.loading = true
      get_templatelist({ id: this.treeId, isLive: this.query.isLive }).then(res => {
        if (res.code != 200) {
          return this.$message.error(res.msg);
        }
        this.loading = false
        this.list = res.data
        console.log(this.list, 'this.list=======================')
      })
    },
    //搜索模板
    search() {
      this.get_list()
    },
    //启用禁用
    setActive(row) {
      set_active({ id: row.id }).then(res => {
        if (res.code != 200) {
          return this.$message.error(res.msg);
        }
        this.get_list()
        this.$message.success('操作成功');
      })
    },
    //删除模板
    delTem(row) {
      var _this = this;
      console.log(row)
      this.$confirm({
        title: '确认删除此模板吗?',
        okText: 'Yes',
        okType: 'danger',
        cancelText: 'No',
        onOk() {
          del_template({ id: row.id }).then(res => {
            if (res.code != 200) {
              return _this.$message.error(res.msg);
            }
            _this.get_list()
            _this.$message.success('删除成功');
          })
        },
        onCancel() {
          console.log('Cancel');
        },
      });

    },
    //打开付款类别维护弹窗
    addType() {
      this.only = false
      get_confiig().then(res => {
        if (res.code != 200) {
          return this.$message.error(res.msg);
        }
        this.isNew = 'add';
        console.log(this.dataRef)
        this.users = [];
        this.modelInfo = {
          id: undefined,
          data: [],
          BaseInformation: {
            level: '',
            name: "",
            processKey: undefined,
            type: this.dataRef.name,
            mark: "",
            cc: "",
            ccs: [],
            isCheckInformation: false,
            isReceived: false,
            // isServicePay: false,
            // isServicePay: false,
            isCheckBill: false,
            isRelationAudit: false,
            isRelationPurchase: false,
            isControllerSelf: false,
            isAlipay: false,
            isFeeDept: false,
            isCheckProjectMoney: false,
            directoryId: this.dataRef.id,
          }
        };
        this.configs = res.data.config;
        this.information = res.data.information;
        this.stepCurrent = 0;
        this.categoryVisible = true;
      })
    },
    //点击查看详情
    delData(row) {
      this.$refs.detailModel.init(row)
    },
    getDirectory() {
      getSecondDir().then(res => {
        if(res.code == 200) {
          this.directoryData = res.data
        } else {
          this.$message.error(res.msg)
        }
      })

    },
    //点击编辑
    editTem(row) {
      this.only = false
      this.getDirectory()
      console.log(row)
      if (row.BaseInformation.live != 0) {
        return this.$message.error('请先禁用模板才可修改！');
      }
      this.isNew = 'edit'
      get_template({ id: row.id }).then(res => {
        if (res.code != 200) {
          return this.$message.error(res.msg);
        }
        get_confiig().then(cof => {
          if (cof.code != 200) {
            return this.$message.error(cof.msg);
          }
         
          if(res.data.detail[0][0].index_name === 'fee_dept') {
            res.data.detail[0].splice(0,1)

          }
           var length = res.data.detail[0].length
          // for(var i = length-1; i >=0 ;i-- ) {
          //   if(res.data.detail[0][i].index_name){
          //     if(res.data.detail[0][i].index_name == 'fee_dept'){
          //     res.data.detail[0].splice(i,1)
          //   }

          //   }
            

          // }
          console.log( res.data.detail[0], 'res.data.detail[0]========')
           res.data.detail[0].splice(length-2,2)
          //  res.data.detail.forEach(item => {
          //    console.log(item.control_id, 'item.control_id==============')
          //      Object.assign(item, {
          //       control_id: '',
          //     })
          //  })
          this.modelInfo = {
            id: res.data.id,
            data: res.data.detail[0],
            BaseInformation: res.data.BaseInformation
          };
          if(res.data.control_id) {
            this.control_id = res.data.control_id
            if(res.data.control_id.length > 0) {
              this.only = true
            }

          }
          
          this.configs = cof.data.config;
          this.information = cof.data.information;
          this.stepCurrent = 0;
          this.categoryVisible = true;
        })
      })
    },
    //添加明细表格
    addItemForm() {
      this.modelInfo.data.push({
        label: "",
        index_name: "",
        type: "",
        value: '',
        id: undefined,
        required: false,
        context: '',
      })
    },
    //移除一个
    removeItemForm(idx) {
      this.modelInfo.data.splice(idx, 1)
    },
    //选项改变
    changeFormItem(e, row, idx) {
      this.configs.forEach(item => {
        if (item.id == e) {
          this.modelInfo.data[idx].label = item.label;
          this.modelInfo.data[idx].index_name = item.index_name;
          this.modelInfo.data[idx].type = item.type;
          this.modelInfo.data[idx].value = item.value;
          this.modelInfo.data[idx].required = item.required;
          this.modelInfo.data[idx].context = item.context;
        }
      })
    },
    //搜索人员
    fetchUser(value) {
      console.log(value)
      this.users = [];
      this.fetching = true;
      getDeptListEnable3({ userName: value }).then(res => {
        this.users = res.rows;
        this.fetching = false;
      })
    },
    //上一步
    preBack() {
      this.stepCurrent -= 1;
    },
    //点击下一步
    submit() {
      if (this.modelInfo.data.length < 1) {
        return this.$message.error('请先添加控件！');
      }
      var is = 1;
      this.modelInfo.data.forEach(item => {
        if (!item.id) {
          is = 0
        }
      })
      if (!is) {
        return this.$message.error('请检查控件是否全部已选！');
      }
      if (this.stepCurrent < 1) {
        this.stepCurrent += 1;
      }

      if (this.stepCurrent > 0) {
        let ccs = this.modelInfo.BaseInformation.ccs;
        var newCs = []
        ccs.forEach(item => {
          newCs.push(item.key)
        })
        this.modelInfo.BaseInformation.level = Number(this.modelInfo.BaseInformation.level)
        this.modelInfo.BaseInformation['cc'] = newCs.join(',')
        this.modelInfo['control_id'] = this.control_id
        console.log( this.modelInfo, ' this.modelInfo====================')
        this.$refs.modelInfo.validate(async valid => {
          if (valid) {
            if (this.isNew == 'add') {
              var res = await add_template(this.modelInfo)
            } else {
              var res = await put_template(this.modelInfo)
            }
            if (res.code != 200) {
              return this.$message.error(res.msg);
            }
            this.get_list()
            this.$message.success('保存成功');
            this.categoryVisible = false
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      }
    }
  },
}
</script>

<style lang="less" scoped>
.containerCenter {
  padding: 10px;
  height: 100%;
  width: 100%;
  float: left;
  background-color: rgb(244, 247, 245);
}

.containerLeft {
  width: 22%;
  height: 100%;
  float: left;
  background-color: rgb(255, 255, 255);
  padding: 0 10px;
  box-sizing: border-box;

  .top {
    width: 100%;
    height: 50px;
    float: left;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .line {
    width: 100%;
    height: 1px;
    background: #ddd;
    float: left;
  }

  .treeBox {
    width: 100%;
    float: left;
    height: calc(100% - 92px);
    overflow-y: scroll;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  .newBtn {
    width: 100%;
    float: left;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;

    .newCBtn {
      width: 80%;
    }
  }
}

.containerRight {
  width: 77%;
  height: 100%;
  float: right;
  padding: 10px;
  background-color: rgb(255, 255, 255);

  .top {
    width: 100%;
    float: left;
    height: 45px;

    .a_enter {
      width: 160px;
      margin-right: 10px;
      float: left;
    }

    .ant-btn+.ant-btn {
      margin-left: 10px !important;
    }
  }
}

.but_type {
  cursor: pointer;
  padding-left: 5px;
  padding-right: 5px;
}

/*修改全局a-tree样式*/
/*全局修改a-tree样式——开始*/
.ant-tree {
  position: relative;
}

.ant-tree>li span.ant-tree-node-content-wrapper::before,
.ant-tree .ant-tree-child-tree>li span.ant-tree-node-content-wrapper::before {
  position: absolute;
  right: 0;
  left: 0;
  height: 24px;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
  content: '';
}

.ant-tree li .ant-tree-node-content-wrapper.ant-tree-node-selected::before {
  background: rgba(173, 224, 251, 0.4);
}

.ant-tree li .ant-tree-node-content-wrapper:hover {
  background-color: transparent;
  color: #000;
}

.ant-tree li .ant-tree-node-content-wrapper:hover .but_operation {
  opacity: 1;
  z-index: 99999;
}

.ant-tree li .ant-tree-node-content-wrapper:hover.ant-tree-node-content-wrapper-normal::before,
.ant-tree li .ant-tree-node-content-wrapper:hover.ant-tree-node-content-wrapper::before {
  background: rgba(173, 224, 251, 0.4);
  color: #000;
}

.ant-tree li .ant-tree-node-content-wrapper.ant-tree-node-selected {
  background: transparent;
}

.ant-tree>li span.ant-tree-node-content-wrapper.ant-tree-node-selected {
  color: #000;
  background: transparent;
}

.ant-tree li span.ant-tree-switcher {
  z-index: 1;
}

.ant-tree li .ant-tree-node-content-wrapper {
  width: calc(100% - 30px);
}

.ant-tree-title {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.containerTop {
  width: 100%;
}

.containerBottom {
  width: 100%;
  margin-top: 15px;

  .view {
    width: 100%;
    border: 1px solid #409EFF;
    padding: 5px 50px 5px 0;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #d9ecff;
    border-radius: 4px;
    color: #409EFF;

    .ico {
      width: 45px;
      height: 40px;
      float: left;
      display: flex;
      justify-content: center;
      align-items: center;

      .circle {
        font-size: 22px;
        color: #409EFF;
      }
    }

    .hiteBox {
      width: calc(100% - 45px);
      float: left;

      .hb {
        font-size: 15px;
        font-weight: 600;
        margin-bottom: 3px;
      }

    }

  }

  .tableSelect {
    width: 100%;
    margin-top: 15px;
  }

  .newSelect {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    .newDetial {
      width: 60%;
      margin-top: 10px;
      border-color: #409EFF !important;
      color: #409EFF !important;

      &:hover {
        background: #e2f1ff !important;
      }
    }
  }

  .selfModel {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .ant-form-item-label {
      line-height: 35px !important;

      label {
        color: #666 !important;
      }
    }

    .ant-form-item {
      width: 30% !important;
    }
  }

  .boxlen {
    width: 100%;
    margin-bottom: 15px;

    .boxtitle {
      width: 100%;
      margin-bottom: 10px;

      .boxlencircle {
        font-size: 16px;
        margin-left: 5px;
        cursor: pointer;
      }
    }

    .sys {
      width: 100%;

      .sysItem {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 24px;
        margin-bottom: 5px;

        .sysTitle {
          white-space: nowrap;
        }

        .sysline {
          width: 100%;
          padding: 0 10px;
          box-sizing: border-box;

          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
    }
  }
}

.modelCate {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 15px 0;
  box-sizing: border-box;
  border: 1px solid #FFA39E;
  border-radius: 3px;
  background: #fbe6e5;
  margin-top: 20px;
}

.formCate .ant-form-item {
  margin-bottom: 0 !important;
}
</style>